module.exports = __webpack_public_path__ + "assets/img/integration.582a7b3f.png";